import { render, staticRenderFns } from "./ReportsColumnBasicChart.vue?vue&type=template&id=29d23734"
import script from "./ReportsColumnBasicChart.vue?vue&type=script&lang=js"
export * from "./ReportsColumnBasicChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports